<script setup>
  import Icon from './icons/Icon.vue';

  const props = defineProps({
    forecasterImageFile: {
      type: String,
      default: null
    },
    seasonStatus: {
      type: String,
      default: null
    },
    size: {
      type: String,
      default: 'base'
    }
  });
</script>

<template>
  <div class="jwx-pro-forecast-list__forecaster-avatar" :data-size="props.size">
    <img v-if="props.forecasterImageFile" :src="`https://cdn-consumer.weatherflow.com/pro-forecasts/forecasters/photos/${props.forecasterImageFile}`" class="jwx-pro-forecast-list__forecaster-photo" />
    <Icon v-else-if="props.seasonStatus === 'out of season'" name="snow-flake" class="jwx-pro-forecast-list__forecaster-icon" />
    <Icon v-else name="user" class="jwx-pro-forecast-list__forecaster-icon" />
  </div>
</template>
